<style>
  .support-index .st-body .ticket-content .ticket-description{
    height: auto;
  }
</style>
<template>
  <div class="support-ticket " @click="seleccionar">
    <div class="st-meta">
      <i class="os-icon os-icon-unlock" v-if="facturae.estado == 'A'"></i>
      <i class="os-icon os-icon-lock" v-if="facturae.estado == 'B'"></i>
      <div class="status-pill green" v-if="facturae.estado == 'A'"></div>
      <div class="status-pill red" v-if="facturae.estado == 'B'"></div>
    </div>
    <div class="st-body" style="dispaly: block;">
      <div class="ticket-content">
        <h6 class="ticket-title">
          {{ facturae.serie }} - {{ facturae.documento }}
        </h6>
        <div class="ticket-description">
          {{ facturae.proveedor }} - {{ facturae.proveedor_obj.nombre }}
          <br>
          Nit: {{ facturae.proveedor_obj.nit }}
        </div>
      </div>
    </div>
    <div class="st-foot text-right">
      <span class="label">Total:</span>
      <span class="value">Q {{ facturae.total_documento }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: ["facturae"],
  computed: {},
  mounted() {},
  methods: {
    seleccionar() {
      let self = this;
      self.$emit("seleccion", self.facturae.id);
    },
  },
};
</script>
